import type { ReactNode } from 'react';

export type AdminTableToolbarProps = {
  /** Omit the three search props to render a filters-only toolbar. */
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  /**
   * Primary filter group (status tabs) — rendered on the search line,
   * pushed to the end side (RTL-safe).
   */
  children?: ReactNode;
  /**
   * Optional secondary group (property types on Deals) — dedicated full
   * line below the search row.
   */
  secondaryRow?: ReactNode;
};

/**
 * Search + filters toolbar shared by the BO list pages (lot ui-bo-polish):
 * one layout, one control height (--admin-control-h), no per-page inline
 * styles. Purely presentational — filtering/search state stays in the page.
 */
export function AdminTableToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  children,
  secondaryRow,
}: AdminTableToolbarProps) {
  return (
    <div className="admin-toolbar">
      <div className="admin-toolbar__row">
        {onSearchChange !== undefined ? (
          <input
            type="search"
            className="admin-toolbar__search"
            placeholder={searchPlaceholder}
            value={searchValue ?? ''}
            onChange={(event) => onSearchChange(event.target.value)}
          />
        ) : null}
        {children ? <div className="admin-toolbar__filters">{children}</div> : null}
      </div>
      {secondaryRow ? <div className="admin-toolbar__row">{secondaryRow}</div> : null}
    </div>
  );
}
